import React from "react";
import styled, { keyframes } from "styled-components";
import Image from "next/image";

import * as u from "../utils";
import * as I from "./Icons";
import * as T from "./Typography";

export default function ImageModal(props) {
  const innerRef = React.useRef(null);
  React.useEffect(attachOutsideClick, []);
  React.useEffect(attachEscKey, []);
  React.useEffect(onBlockScroll, []);
  const [imageError, setImageError] = React.useState(!props.src);
  const [imageSrc, setImageSrc] = React.useState(props.src);

  return (
    <S.Container data-cy="image-modal">
      <S.Cross onClick={onClose} color="white" height={21} width={21} />
      <S.InnerContainer ref={innerRef}>
        {!imageError ? (
          <Image
            src={imageSrc || ""}
            layout="fill"
            objectFit="contain"
            onError={onImageError}
          />
        ) : (
          <S.TCXL>The selected image cannot be found</S.TCXL>
        )}
      </S.InnerContainer>
    </S.Container>
  );

  function onImageError() {
    if (imageSrc.includes("_800x800") || imageSrc.includes("_400x400")) {
      setImageSrc(imageSrc.replace("_800x800", "").replace("_400x400", ""));
      return setImageError(false);
    } else {
      return setImageError(true);
    }
  }

  function onBlockScroll() {
    document.body.setAttribute("style", "overflow: hidden;");
    return () => document.body.setAttribute("style", "overflow: visible;");
  }

  function attachOutsideClick() {
    document.addEventListener("click", onMaybeOutside);
    return () => document.removeEventListener("click", onMaybeOutside);

    function onMaybeOutside(evt) {
      if (innerRef.current?.contains(evt.target)) return;
      onClose();
    }
  }

  function attachEscKey() {
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);

    function onKeyDown(evt) {
      if (evt.key === "Escape") onClose();
      return;
    }
  }

  function onClose() {
    if (props.onClose) props.onClose();
  }
}

const S = {};

S.Fade = keyframes`
  100% {opacity: 1}
`;

S.Container = styled.div`
  animation: ${S.Fade} 0.2s ease-out forwards;
  z-index: 99;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: hsla(0, 0%, 0%, 0.9);
  display: flex;
  opacity: 0;
`;

S.Cross = styled(I.Cross)`
  position: absolute;
  top: 40px;
  right: 40px;
  cursor: pointer;
  z-index: 1;
`;

S.InnerContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: auto;
  max-height: 80vh;
  max-width: 80vw;
  overflow: hidden;
  position: relative;
  width: 100%;

  @media ${u.device.tablet} {
    max-width: 550px;
  }
`;

S.TCXL = styled(T.CXL)`
  color: white;
  text-align: center;
`;
